module.exports = __webpack_public_path__ + "img/1_4_zips.758dd219.svg";